module.exports = __webpack_public_path__ + "static/media/chart.7f2d1e87.svg";